import React from 'react';

import { generateMatrixData } from './ClassificationUtil';
import { useParams } from 'react-router-dom';
import { useList } from '../hooks/listHook';
import EmptyList from '../useful/EmptyList';
import { clasifiedTeams } from '../TeamList/TeamsUtil';
import { getTeamWinnerUid } from '../Matches/MatchesUtil';

const ClassificationElimination = (props) => {

    const { tournament, teams } = props;

    if (tournament.matchesGenerated) {
        return <ClassificationEliminationMatches teams={teams} firebase={props.firebase} />
    }
    return <ClassificationEliminationTeams teams={teams} />
}

const ClassificationEliminationMatches = (props) => {

    const { tournament_uid } = useParams(); // tournament uid
    const userId = props.firebase.auth.currentUser.uid; // user auth uid

    const { teams } = props;

    const { loading, list: matches } = useList(props.firebase.matchCollection(userId, tournament_uid)
        .where("matchday.index", ">=", 10000).orderBy("matchday.index").orderBy("index"), tournament_uid);

    if (loading)
        return (
            <div className="nav justify-content-center pt-2">
                <small>Cargando...</small>
            </div>
        )
    if (!matches) {
        return <EmptyList />
    }

    const data = generateMatrixData(matches);

    return <EliminationDiagram data={data} teams={teams} />

}

const ClassificationEliminationTeams = (props) => {

    const { teams } = props;

    const cTeams = clasifiedTeams(teams);
    const nTeams = cTeams.length;

    if (nTeams >= 2 && nTeams <= 128 && (Math.log2(nTeams) % 1 === 0)) {
        const matches = new Array(nTeams - 1);
        let matchIndex = 0;
        for (let i = 0; i < nTeams; i += 2) {
            let teamA = cTeams[i];
            let teamB = cTeams[i + 1];
            const match = {
                index: matchIndex,
                teamA: teamA.uid,
                teamB: teamB.uid,
            };
            matches[matchIndex++] = match;
        }
        for (let i = matchIndex; i < matches.length; i++) {
            const match = {
                index: matchIndex++
            };
            matches[i] = match;
        }

        const data = generateMatrixData(matches);

        return <EliminationDiagram data={data} teams={teams} />
    }

    return <EmptyList />
}

const EliminationDiagram = (props) => {

    const { data, teams } = props;

    // const data = generateMatrixData();
    const matrix = data.matrix;
    const headers = data.headers;

    const percent = (100 / headers.length) + '%';
    const styleTh = { width: percent }

    return (
        <div className="table-responsive-md">
            <table className="small table table-sm table-borderless">
                <thead>
                    <tr>
                        {headers.map((item, i) => {
                            let colSpan = 3
                            if (i === 0 || i === headers.length - 1)
                                colSpan = 2;
                            return <th style={styleTh} key={i} colSpan={colSpan} className="align-middle text-center">{item}</th>
                        })}
                    </tr>
                </thead>
                <tbody>
                    <tr></tr>
                    {matrix.map((row, i) => {
                        return (
                            <tr key={i}>
                                {row.map((column, j) => {

                                    let cellComponent = <></>;
                                    if (column.match) {
                                        let componentClass = i % 2 === 0 ? " rounded-top" : " rounded-bottom";
                                        const teamEmpty = i % 2 === 0 ?
                                            <span className="text-nowrap text-black-50 font-italic">ganador &#8624;</span>
                                            :
                                            <span className="text-nowrap text-truncate text-black-50 font-italic">ganador &#8626;</span>;

                                        const teamUid = i % 2 === 0 ? column.match.teamA : column.match.teamB;
                                        const winnerUid = getTeamWinnerUid(column.match, column.match.result);
                                        componentClass += (teamUid === winnerUid) ? " teamWinnerClass" : "";
                                        const team = teams.find(item => item.uid === teamUid);
                                        let teamComponent = teamEmpty;
                                        if (team) {
                                            teamComponent = <DiagramTeamItem team={team} />
                                        }
                                        cellComponent = <div className={"border  bg-gray  p-1 " + componentClass}>{teamComponent}</div>
                                    }

                                    return <td key={j} className={" " + column.className}>
                                        {cellComponent}
                                    </td>
                                })}
                            </tr>
                        )
                    })}

                </tbody>
            </table>
        </div>
    )
}


const DiagramTeamItem = (props) => {
    const { team } = props;
    const teamLogo = (team && team.logoUrl) ? team.logoUrl : process.env.PUBLIC_URL + "/team_logo.png"
    return (
        <table>
            <tbody>
                <tr>
                    <td className="p-0 align-middle" style={{ width: 22 }}>
                        <div style={{
                            backgroundImage: `url(${teamLogo})`,
                            height: 20,
                            width: 20,
                            minWidth: 20,
                            backgroundPosition: 'center',
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat'
                        }} />
                    </td>
                    <td className="p-0 align-middle">
                        <span className="text-wrap">{team.title}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    )

}




export default ClassificationElimination;